import { render } from "./StockManagement.vue?vue&type=template&id=8b907460&scoped=true"
import script from "./StockManagement.vue?vue&type=script&lang=js"
export * from "./StockManagement.vue?vue&type=script&lang=js"

import "./StockManagement.vue?vue&type=style&index=0&id=8b907460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b907460"]])

export default __exports__